<script setup lang="ts">
import type { ComponentStyles } from 'types/index';

const props = defineProps<{
  data: SpacerBlockContent;
  componentStyles: ComponentStyles;
}>();

const textColor = props.data.textColor?.color ? `color:#${props.data.textColor.color};` : '';
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <article class="relative py-10 lg:py-40">
      <HumbleScroll
        animation="zoom-in"
        class="absolute inset-0 size-full overflow-hidden"
        inner-class="size-full"
        :variables="{ duration: '1.5s' }"
      >
        <div
          v-if="data.brightnessSlider"
          class="absolute inset-0 size-full bg-black"
          :style="{ opacity: data.brightnessSlider / 100 }"
        />
        <figure
          v-if="data.image && data.image.url"
          class="size-full"
        >
          <BaseImage
            class="size-full object-cover"
            :image="data.image"
            :is-decorative="true"
            sizes="100vw lg:100vw"
          />
        </figure>
      </HumbleScroll>

      <div
        v-if="data.text || data.header"
        class="container relative lg:grid lg:grid-cols-12 lg:gap-6"
      >
        <div
          class="lg:col-span-8 lg:col-start-3"
          :style="textColor"
        >
          <HumbleScroll animation="fade up">
            <div class="flex flex-col items-center gap-4 text-center lg:gap-6">
              <h2
                v-if="data.header"
                class="text-h1 lg:text-h2"
              >
                {{ data.header }}
              </h2>

              <p
                v-if="data.text"
                class="quote-content mx-auto max-w-[100ch] text-h3"
              >
                {{ data.text }}
              </p>
            </div>
          </HumbleScroll>
        </div>
      </div>
    </article>
  </BaseComponentWrapper>
</template>
